import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AppVersion } from '@core';
import { UpdateService } from '@update/infra';
import { VersionDataModel } from '../../../models';

export class IsNewestVersionQueryHandler {
  private readonly updateService: UpdateService = inject(UpdateService);

  isNewestVersion(): Observable<boolean> {
    return this.updateService.newestVersion().pipe(map((newest: string) => !this.isVersionGreater(newest)));
  }

  private isVersionGreater(newestVersion: string): boolean {
    if (AppVersion === newestVersion) return false;

    const newest: VersionDataModel = this.splitVersion(newestVersion);
    const current: VersionDataModel = this.splitVersion(AppVersion);

    if (newest.major !== current.major) return newest.major > current.major;
    if (newest.minor !== current.minor) return newest.minor > current.minor;
    if (newest.build !== current.build) return newest.build > current.build;

    return false;
  }

  private splitVersion(version: string): VersionDataModel {
    const parts: string[] = version.split('.');
    return {
      major: +parts[0],
      minor: +parts[1],
      build: +parts[2]
    };
  }
}
